// src/App.js
import React from 'react';
import FlashcardList from './components/FlashcardList';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Flashcard App</h1>
      <FlashcardList />
    </div>
  );
}

export default App;
